import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { QuestionBase } from '../../helpers/dynamic-form/question-base';
import { QuestionControlService } from '../../helpers/dynamic-form/question-control.service';

@Component({
  selector: 'app-dynamic-form',
  templateUrl: './dynamic-form.component.html',
  providers: [ QuestionControlService ]
})
export class DynamicFormComponent implements OnInit {

  @Input() questions: QuestionBase<any>[] = [];
  @Output()
  change: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
  form: FormGroup;
  payLoad = '';

  constructor(private qcs: QuestionControlService) {  }

  ngOnInit() {
    this.form = this.qcs.toFormGroup(this.questions);
    this.change.emit(this.form);
    this.form.valueChanges.subscribe(res => this.change.emit(this.form));
  }

  onSubmit() {
    this.payLoad = JSON.stringify(this.form.value);
  }
}



// WEBPACK FOOTER //
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/src/app/components/dynamic-form/dynamic-form.component.ts